<template>
  <div id="app" v-loading.fullscreen="loading">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app',

  created() {
    this.$store.commit('core/ga', this.$ga);
    this.$store.dispatch('auth/setup');
  },

  computed: {
    ...mapGetters({
      loading: 'auth/loading',
      authenticated: 'auth/authenticated',
      authModalHeader: 'auth/modalHeader',
      authModalErrorMessage: 'auth/modalErrorMessage',
      authModalOnBeforeSignIn: 'auth/modalOnBeforeSignIn',
    }),

    authModalOpened: {
      get() {
        return this.$store.getters['auth/modalOpened'];
      },

      set(value) {
        if (!value) {
          this.$store.dispatch('auth/closeModal');
        }
      },
    },
  },
};
</script>
